<template>
  <div>
    <h2 class="step-name">Email Notifications</h2>

    <div class="step-section" >
      <div v-for="notification in getFieldValue('notifications')" :key="notification.slug">
        <label :class="notification.marked || notification.auto_generated ? '':'comment-disabled'">
          <span class="glyphicon glyphicon-envelope" aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Email might be generated"></span>
          {{ notification.name }}
          <template v-if="notification.slug == 'dc-disclaimer-and-teatseal-documentation' && getFieldValue('regulation_email_sent_at', 'Disclaimer')">
            <i class="glyphicon glyphicon-ok" v-tooltip="'Email already sent'" style="margin-left: 5px; color: green"></i>
          </template>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'EmailNotifications',
  mixins: [ baseComponent ],
  created()
  {
    this.setEmailNotification({
      slug: 'dc-disclaimer-and-teatseal-documentation',
      value: !this.getFieldValue('regulation_email_sent_at', 'Disclaimer'),
    })
  }
};
</script>
